import Image from 'next/image';
import Link from 'next/link';

const HomepageFooter = () => {
  return (
    <footer className="bg-[#fff] text-[#2E2A3A] pt-20 pb-[20px]">
      <div className="max-w-[1490px] mx-auto px-[20px]">
        <div className="flex justify-between items-start mb-16">
          {/* Logo & Tagline */}
          <div>
            <div className="mb-4">
              <Image
                src="/fff-footer-logo.png"
                alt="Female Fitness Finder"
                width={360}
                height={120}
                className="object-contain"
              />
            </div>
            <p className="font-['Archivo',sans-serif] text-[20px] text-[#2E2A3A]">Finding female-led fitness, for you</p>
          </div>

          {/* Social & Contact */}
          <div className="flex flex-col items-end gap-[40px]">
            <div className="flex items-center gap-[40px]">
              <a href="#" className="text-[#2E2A3A] hover:opacity-70 transition-opacity">
                <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                </svg>
              </a>
              <a href="#" className="text-[#2E2A3A] hover:opacity-70 transition-opacity">
                <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zM5.838 12a6.162 6.162 0 1112.324 0 6.162 6.162 0 01-12.324 0zM12 16a4 4 0 110-8 4 4 0 010 8zm4.965-10.405a1.44 1.44 0 112.881.001 1.44 1.44 0 01-2.881-.001z"/>
                </svg>
              </a>
              <a href="#" className="text-[#2E2A3A] hover:opacity-70 transition-opacity">
                <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M19.59 6.69a4.83 4.83 0 01-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 01-5.2 1.74 2.89 2.89 0 012.31-4.64 2.93 2.93 0 01.88.13V9.4a6.84 6.84 0 00-1-.05A6.33 6.33 0 005 20.1a6.34 6.34 0 0010.86-4.43v-7a8.16 8.16 0 004.77 1.52v-3.4a4.85 4.85 0 01-1-.1z"/>
                </svg>
              </a>
            </div>
            <div className="flex items-center gap-[40px] font-['Archivo',sans-serif] text-[16px]">
              <div className="flex items-center gap-2">
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"/>
                </svg>
                <span>+44 750 753 5943</span>
              </div>
              <div className="w-px h-5 bg-white/30"></div>
              <div className="flex items-center gap-2">
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/>
                </svg>
                <span>tia@femalefitnessfinder.com</span>
              </div>
            </div>
          </div>
        </div>

        {/* Navigation */}
        <div className="flex justify-between mb-12">
          <Link href="/" className="font-['Archivo',sans-serif] text-[18px] text-[#2E2A3A] hover:opacity-70 transition-opacity">Home</Link>
          <Link href="/about" className="font-['Archivo',sans-serif] text-[18px] text-[#2E2A3A] hover:opacity-70 transition-opacity">About</Link>
          <Link href="/directory" className="font-['Archivo',sans-serif] text-[18px] text-[#2E2A3A] hover:opacity-70 transition-opacity">Directory</Link>
          <Link href="/for-women" className="font-['Archivo',sans-serif] text-[18px] text-[#2E2A3A] hover:opacity-70 transition-opacity">For Women</Link>
          <Link href="/contact" className="font-['Archivo',sans-serif] text-[18px] text-[#2E2A3A] hover:opacity-70 transition-opacity">Contact</Link>
        </div>

        {/* Bottom Section */}
        <div className="flex justify-between items-center pt-8 border-t border-white/20">
          <p className="font-['Archivo',sans-serif] text-[16px] text-[#2E2A3A]">
            Copyright © 2026 <span className="opacity-70">Female Fitness Finder.</span> All rights reserved.
          </p>
          <div className="flex gap-8">
            <Link href="/privacy" className="font-['Archivo',sans-serif] text-[16px] text-[#2E2A3A] hover:opacity-70 transition-opacity">Privacy Policy</Link>
            <Link href="/terms" className="font-['Archivo',sans-serif] text-[16px] text-[#2E2A3A] hover:opacity-70 transition-opacity">Terms & Conditions</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default HomepageFooter;
